export default __webpack_public_path__ + "static/my-nav-logo-1ed0b120c70d0f80fff7bb4b16525f78.svg";